import { createMultiStyleConfigHelpers as o } from "@chakra-ui/styled-system";
const t = o([
  "container",
  "navigationItemBtn",
  "menuList",
  "menuItem"
]), r = t.defineMultiStyleConfig({
  baseStyle: ({ theme: n }) => ({
    container: {
      paddingTop: n.menuExtraSmallPadding,
      paddingBottom: n.menuMediumInnerSpacing,
      borderBottom: `2px solid ${n.action.tertiaryDefault}`
    },
    navigationItemBtn: {
      display: "flex",
      alignItems: "center",
      py: n.menuExtraSmallInnerSpacing,
      ...n.menuDefaultButton,
      _hover: { textDecoration: "none" }
    },
    menuList: {
      py: n.menuMediumPadding,
      px: n.menuLargePadding,
      boxShadow: n.elevation.low,
      ".menu-item:last-child": {
        mb: 0
      }
    },
    menuItem: {
      p: 0,
      mb: n.menuLargeInnerSpacing,
      _focus: {
        bg: "inherit",
        textDecoration: n.menubuttonUnderline
      },
      ...n.menuDefaultButton
    }
  }),
  variants: {
    dark: ({ theme: n }) => ({
      container: {
        _hover: {
          borderBottom: `2px solid ${n.border.accent1}`
        },
        _active: {
          borderBottom: `2px solid ${n.border.accent1}`
        }
      },
      navigationItemBtn: {
        color: n.menu.default,
        _hover: {
          color: n.menu.hover
        },
        _active: {
          color: n.menu.selected
        }
      }
    }),
    light: ({ theme: n }) => ({
      container: {
        _hover: {
          borderBottom: `2px solid ${n.border.onPrimary}`
        },
        _active: {
          borderBottom: `2px solid ${n.border.onPrimary}`
        }
      },
      navigationItemBtn: {
        color: n.menu.lightDefault,
        _hover: {
          color: n.menu.lightHover
        },
        _active: {
          color: n.menu.lightSelected
        }
      }
    })
  },
  defaultProps: {
    variant: "dark"
  }
});
export {
  r as default
};
